/// <amd-module name="Dashboards/DashboardView/src/components/headers/CopyDashboardManager" />
import * as React from "react";
import { connect } from "react-redux";

import { DashboardViewAwareState } from "../../model/DashboardViewState";
import { DashboardActions } from "../../redux/actions/Actions";
import * as DashboardPanelConstants from "Dashboards/DashboardPanel/Common";
import * as Selectors from "../../redux/selectors/Selectors";

import { Dashboard } from "Dashboards/Common/Contracts/Dashboard";
import { TeamContext } from"Dashboards/Common/Contracts/TeamContext";
import { CopyDashboardPanel } from "Dashboards/DashboardPanel/CopyDashboardPanel";

import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";

interface ConnectedCopyDashboardManagerOwnProps {
    teamContext: TeamContext;
}

interface ConnectedCopyDashboardManagerMappedProps {
    dashboard: Dashboard;
    projects: DashboardPanelConstants.Project[];
    projectTeamMap: {[id:string]: DashboardPanelConstants.TeamProjectItem};
    useDedicatedApi: boolean;
}

interface CopyDashboardManagerProps extends ConnectedCopyDashboardManagerOwnProps, ConnectedCopyDashboardManagerMappedProps {}

class CopyDashboardManager extends VssComponent<CopyDashboardManagerProps & typeof Actions> {

    public constructor(props: CopyDashboardManagerProps & typeof Actions, context?: IVssComponentContext) {
        super(props, context);
    }

    public async componentDidMount(): Promise<void> {
    }

    public render(): JSX.Element {
        const {teamContext, projects, dashboard, projectTeamMap, useDedicatedApi } = this.props
        return <CopyDashboardPanel
                onDashboardCopied={this.props.onCopyDashboardSuccess}
                onDismiss={this.props.onDismissCopyDashboard}
                onLoadNewTeamsForProject={this.props.onLoadNewTeamsForProject}
                project={{id:teamContext.projectId, name:teamContext.project}}
                projects={projects}
                dashboard={dashboard}
                team={{id: teamContext.teamId, name: teamContext.team}}
                projectTeamMap={projectTeamMap}
                useDedicatedApi={useDedicatedApi}
            />    
    }
}

const Actions = {
    onDismissCopyDashboard: DashboardActions.hideCopyDashboardPanel,
    onCopyDashboardSuccess: DashboardActions.navigateToDashboard,
    onLoadNewTeamsForProject: DashboardActions.loadNewTeamsForProject
};

function mapStateToProps(state: DashboardViewAwareState): ConnectedCopyDashboardManagerMappedProps {
    return {
        dashboard: Selectors.packServerDashboard(state),
        projects: Selectors.getCopyDashboardProjectsList(state)!,
        projectTeamMap: Selectors.getCopyDashboardProjectTeamList(state),
        useDedicatedApi: Selectors.getCopyDashboardDedicatedApiEnabled(state)
    };
}

export const ConnectedCopyDashboardManager = connect(
    mapStateToProps,
    Actions
)(CopyDashboardManager);
